// Simple i18n dictionary for EN / DE
export const LANGUAGES = ["en", "de"];

const dict = {
  common: {
    save: { en: "Save", de: "Speichern" },
    cancel: { en: "Cancel", de: "Abbrechen" },
    continue: { en: "Continue", de: "Weiter" },
    edit: { en: "Edit", de: "Bearbeiten" },
    add: { en: "Add", de: "Hinzufügen" },
    remove: { en: "Remove", de: "Entfernen" },
    close: { en: "Close", de: "Schließen" },
    loading: { en: "Loading…", de: "Lädt…" },
    yes: { en: "Yes", de: "Ja" },
    no: { en: "No", de: "Nein" },
    search: { en: "Search", de: "Suche" },
    total: { en: "Total", de: "Gesamt" },
    apply: { en: "Apply", de: "Anwenden" },
    clear: { en: "Clear", de: "Löschen" },
    copy: { en: "Copy", de: "Kopieren" },
    copied: { en: "Copied", de: "Kopiert" },
    open: { en: "Open", de: "Offen" },
    closed: { en: "Closed", de: "Geschlossen" },
    mondayShort: { en: "Mon", de: "Mo" },
    tuesdayShort: { en: "Tue", de: "Di" },
    wednesdayShort: { en: "Wed", de: "Mi" },
    thursdayShort: { en: "Thu", de: "Do" },
    fridayShort: { en: "Fri", de: "Fr" },
    saturdayShort: { en: "Sat", de: "Sa" },
    sundayShort: { en: "Sun", de: "So" },
    signedInAs: { en: "Signed in as", de: "Angemeldet als" },
    saved: { en: "Saved", de: "Gespeichert" },
    saveFailed: { en: "Save failed", de: "Speichern fehlgeschlagen" },
    fileTooLarge: { en: "File too large (max 5 MB)", de: "Datei zu groß (max. 5 MB)" },
  },
  nav: {
    home: { en: "Home", de: "Startseite" },
    myDealership: { en: "My Dealership", de: "Mein Autohaus" },
    myDealerships: { en: "My Dealerships", de: "Meine Autohäuser" },
    legalPages: { en: "Legal Pages", de: "Impressum" },
    legalHtmlEditor: { en: "Legal HTML Editor", de: "Impressum-HTML-Editor" },
    departments: { en: "Departments", de: "Abteilungen" },
    dealers: { en: "Dealers", de: "Autohäuser" },
    integrations: { en: "Integrations", de: "Integrationen" },
    users: { en: "Users", de: "Benutzer" },
    settings: { en: "Settings", de: "Einstellungen" },
    profile: { en: "Profile", de: "Profil" },
    logout: { en: "Log out", de: "Abmelden" },
    audit: { en: "Audit Log", de: "Audit-Protokoll" },
  },
  login: {
    title: { en: "Sign in", de: "Anmelden" },
    subtitle: {
      en: "Access the Dealer Network Data Platform",
      de: "Zugang zur Händlernetz-Datenplattform",
    },
    email: { en: "Email address", de: "E-Mail-Adresse" },
    password: { en: "Password", de: "Passwort" },
    submit: { en: "Sign in", de: "Anmelden" },
    invalid: { en: "Invalid email or password", de: "Ungültige E-Mail oder Passwort" },
    forgotPassword: { en: "Forgot password?", de: "Passwort vergessen?" },
    poweredBy: { en: "Powered by OneDealer", de: "Powered by OneDealer" },
    enterPlatform: { en: "Enter Platform", de: "Plattform betreten" },
    ssoSubmit: { en: "Sign in with SSO", de: "Mit SSO anmelden" },
    ssoNoAccount: {
      en: "No account found for this email — contact your admin",
      de: "Kein Konto für diese E-Mail-Adresse gefunden — wenden Sie sich an Ihren Administrator",
    },
    ssoAccountDeactivated: {
      en: "This account has been deactivated — contact your admin",
      de: "Dieses Konto wurde deaktiviert — wenden Sie sich an Ihren Administrator",
    },
    ssoFailed: {
      en: "SSO sign-in failed — please try again",
      de: "SSO-Anmeldung fehlgeschlagen — bitte versuchen Sie es erneut",
    },
  },
  forgotPassword: {
    title: { en: "Reset your password", de: "Passwort zurücksetzen" },
    subtitle: {
      en: "Enter your email and we'll send you a reset link.",
      de: "Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen einen Link zum Zurücksetzen.",
    },
    email: { en: "Email address", de: "E-Mail-Adresse" },
    submit: { en: "Send reset link", de: "Link senden" },
    sent: {
      en: "If an account exists for that email, a reset link is on its way.",
      de: "Falls ein Konto mit dieser E-Mail existiert, ist ein Link zum Zurücksetzen unterwegs.",
    },
    backToLogin: { en: "Back to sign in", de: "Zurück zur Anmeldung" },
  },
  resetPassword: {
    title: { en: "Choose a new password", de: "Neues Passwort wählen" },
    newPassword: { en: "New password", de: "Neues Passwort" },
    confirmPassword: { en: "Confirm password", de: "Passwort bestätigen" },
    submit: { en: "Reset password", de: "Passwort zurücksetzen" },
    mismatch: { en: "Passwords do not match", de: "Passwörter stimmen nicht überein" },
    success: {
      en: "Your password has been reset. You can now sign in.",
      de: "Ihr Passwort wurde zurückgesetzt. Sie können sich jetzt anmelden.",
    },
    invalidLink: {
      en: "This reset link is invalid or has expired.",
      de: "Dieser Link ist ungültig oder abgelaufen.",
    },
    backToLogin: { en: "Back to sign in", de: "Zurück zur Anmeldung" },
  },
  impersonation: {
    banner: {
      en: "Impersonating dealer",
      de: "Händler-Impersonation aktiv",
    },
    stop: { en: "Stop impersonation", de: "Impersonation beenden" },
    start: { en: "Impersonate", de: "Impersonieren" },
    search: { en: "Search dealer to impersonate…", de: "Händler zum Impersonieren suchen…" },
  },
  home: {
    welcome: {
      en: (name) => `Welcome, ${name}`,
      de: (name) => `Willkommen, ${name}`,
    },
    subtitle: {
      en: "Manage your dealership's contacts, branch info, opening hours and legal pages.",
      de: "Verwalten Sie die Kontakte, Filialdaten, Öffnungszeiten und Rechtsseiten Ihres Autohauses.",
    },
    myDealershipHint: {
      en: "Main contact, address, coordinates, services & opening hours.",
      de: "Hauptkontakt, Adresse, Koordinaten, Services & Öffnungszeiten.",
    },
    legalPagesHint: {
      en: "Structured Impressum data used by your dealer website.",
      de: "Strukturierte Impressumsdaten für Ihre Händler-Website.",
    },
    dealerCode: { en: "Dealer Code", de: "Händlercode" },
    companyId: {
      en: (id) => `Company ID ${id}`,
      de: (id) => `Firmen-ID ${id}`,
    },
    offeringHint: {
      en: (type) => `Dealers offering ${type}`,
      de: (type) => `Händler mit ${type}`,
    },
    statsError: { en: "Failed to load stats.", de: "Statistiken konnten nicht geladen werden." },
  },
  dashboard: {
    title: { en: "Network overview", de: "Netzwerk-Überblick" },
    subtitle: {
      en: "Master data snapshot for the entire dealer network.",
      de: "Stammdaten-Überblick über das gesamte Händlernetz.",
    },
    serviceTypes: { en: "Service types", de: "Servicetypen" },
    missingCoords: { en: "Missing coordinates", de: "Fehlende Koordinaten" },
    missingCoordsSub: {
      en: "Dealers whose branches have no long/lat set.",
      de: "Händler ohne Längen-/Breitengrad an ihren Filialen.",
    },
    sitesCount: { en: "Dealer sites", de: "Händlerseiten" },
    sitesSub: {
      en: "Dealers with an active website URL configured.",
      de: "Händler mit hinterlegter Website-URL.",
    },
    counts: { en: "Counts", de: "Anzahl" },
    total: { en: "Total dealers", de: "Händler gesamt" },
  },
  dealers: {
    title: { en: "Dealers", de: "Autohäuser" },
    filterPredefined: { en: "Predefined filter", de: "Vordefinierter Filter" },
    filterTags: { en: "Tags", de: "Tags" },
    filterActivation: {
      en: "Participating in activation…",
      de: "Nimmt an Aktivierung teil…",
    },
    filterMissingCoords: {
      en: "Missing coordinates",
      de: "Fehlende Koordinaten",
    },
    filterStatusActive: { en: "Show Active", de: "Aktive anzeigen" },
    filterStatusDeleted: { en: "Show Deleted", de: "Gelöschte anzeigen" },
    filterStatusAll: { en: "Show All", de: "Alle anzeigen" },
    clearFiltering: { en: "Clear Filtering", de: "Filter zurücksetzen" },
    deletedBadge: { en: "Deleted", de: "Gelöscht" },
    copyCodes: {
      en: "Copy Dealer Codes",
      de: "Händlercodes kopieren",
    },
    columns: {
      code: { en: "Dealer Code", de: "Händlercode" },
      name: { en: "Name", de: "Name" },
      city: { en: "City", de: "Stadt" },
      tags: { en: "Tags", de: "Tags" },
    },
    resultsCount: {
      en: (n) => `${n} dealer${n === 1 ? "" : "s"}`,
      de: (n) => `${n} Händler`,
    },
    noResults: { en: "No dealers match.", de: "Keine Händler gefunden." },
    bulkUpdateButton: { en: "Bulk Update", de: "Massenaktualisierung" },
  },
  dealership: {
    mainContact: { en: "Main Contact", de: "Hauptkontakt" },
    mainContactSub: {
      en: "Additional dealer-level contact used for internal MHQ ↔ dealer communication.",
      de: "Zusätzlicher Händler-Kontakt für die interne Kommunikation MHQ ↔ Händler.",
    },
    name: { en: "Name", de: "Name" },
    email: { en: "Email", de: "E-Mail" },
    branchInfo: { en: "Branch Info", de: "Filialdaten" },
    branchInfoSub: {
      en: "Address, contact URL, geographic coordinates.",
      de: "Adresse, Kontakt-URL, geografische Koordinaten.",
    },
    address: { en: "Address", de: "Adresse" },
    street: { en: "Street", de: "Straße" },
    zip: { en: "ZIP", de: "PLZ" },
    city: { en: "City", de: "Stadt" },
    website: { en: "Website", de: "Website" },
    coordinates: { en: "Coordinates", de: "Koordinaten" },
    coordinatesEdit: { en: "Edit coordinates", de: "Koordinaten bearbeiten" },
    viewOnMaps: { en: "View on Google Maps", de: "Auf Google Maps anzeigen" },
    services: { en: "Services", de: "Services" },
    servicesSub: {
      en: "Service records are managed automatically. Contacts and opening hours are editable here.",
      de: "Servicedatensätze werden automatisch gepflegt. Kontakte und Öffnungszeiten sind hier editierbar.",
    },
    contacts: { en: "Contacts", de: "Kontakte" },
    openingHours: { en: "Opening hours", de: "Öffnungszeiten" },
    addInterval: { en: "Add interval", de: "Intervall hinzufügen" },
    saved: { en: "Saved", de: "Gespeichert" },
    telephone: { en: "Telephone", de: "Telefon" },
    mobile: { en: "Mobile", de: "Mobil" },
    fax: { en: "Fax", de: "Fax" },
    linkLegal: { en: "View Legal Pages Data", de: "Impressum-Daten anzeigen" },
    mainDataChange: {
      title: { en: "Main Data Change", de: "Änderung der Stammdaten" },
      hint: {
        en: "Request the change of any piece of information that you are not allowed to change through the platform",
        de: "Fordern Sie die Änderung von Informationen an, die Sie über die Plattform nicht selbst ändern können",
      },
      button: { en: "Request Data Change", de: "Datenänderung anfordern" },
    },
    feedData: { en: "Feed Data", de: "Feed-Daten" },
    salesCapability: { en: "Sales", de: "Verkauf" },
    serviceCapability: { en: "Service", de: "Service" },
    openingHoursNote: { en: "Opening hours note", de: "Öffnungszeiten-Hinweis" },
    identifiers: { en: "Identifiers", de: "Kennungen" },
    kvpsId: { en: "KVPS ID", de: "KVPS-ID" },
    kvpsNo: { en: "KVPS No.", de: "KVPS-Nr." },
    kvpsNoId: { en: "KVPS No. ID", de: "KVPS-Nr.-ID" },
    companyInternalId: { en: "Company Internal ID", de: "Interne Firmen-ID" },
    mdHash: { en: "MD hash", de: "MD-Hash" },
    mdHashReveal: { en: "Click to reveal", de: "Zum Anzeigen klicken" },
    mdHashHide: { en: "Hide", de: "Verbergen" },
    mdHashUnavailable: { en: "not generated (no secret key configured)", de: "nicht erzeugt (kein geheimer Schlüssel konfiguriert)" },
    mdHashLoadFailed: { en: "Could not load the MD hash", de: "MD-Hash konnte nicht geladen werden" },
    managementMigratedToDdm: { en: "Management migrated to DDM", de: "Verwaltung zu DDM migriert" },
    customData: {
      title: { en: "Custom Data", de: "Individuelle Daten" },
      mhqManaged: { en: "MHQ-managed", de: "MHQ-verwaltet" },
      dealerManaged: { en: "Dealer-managed", de: "Händler-verwaltet" },
      noMhqFields: { en: "No fields yet.", de: "Noch keine Felder." },
      jobPostingsUrl: { en: "Job Postings URL", de: "URL für Stellenanzeigen" },
      tradeInUrl: { en: "Trade-In URL", de: "URL für Inzahlungnahme" },
    },
    logo: {
      title: { en: "Dealer Logo", de: "Händlerlogo" },
      none: { en: "No logo", de: "Kein Logo" },
      upload: { en: "Upload logo", de: "Logo hochladen" },
      replace: { en: "Replace logo", de: "Logo ersetzen" },
      delete: { en: "Delete logo", de: "Logo löschen" },
      refresh: { en: "Re-import from feed", de: "Aus Feed neu importieren" },
      noFeedLogo: { en: "The feed has no logo URL for this dealer", de: "Der Feed enthält keine Logo-URL für diesen Händler" },
      deleteConfirm: { en: "Delete this dealer's logo?", de: "Logo dieses Händlers löschen?" },
      refreshConfirm: {
        en: "Re-download the logo from the feed? This overwrites the current logo.",
        de: "Logo erneut aus dem Feed laden? Das aktuelle Logo wird überschrieben.",
      },
      uploaded: { en: "Logo uploaded", de: "Logo hochgeladen" },
      uploadFailed: { en: "Logo upload failed", de: "Logo-Upload fehlgeschlagen" },
      deleted: { en: "Logo deleted", de: "Logo gelöscht" },
      deleteFailed: { en: "Could not delete logo", de: "Logo konnte nicht gelöscht werden" },
      refreshed: { en: "Logo re-imported from feed", de: "Logo aus dem Feed neu importiert" },
      refreshFailed: { en: "Could not re-import logo", de: "Logo konnte nicht neu importiert werden" },
    },
    internalContact: {
      title: { en: "Dealer contact (Internal for SAD)", de: "Händlerkontakt (intern für SAD)" },
      name: { en: "Name", de: "Name" },
      email: { en: "Email", de: "E-Mail" },
      phone: { en: "Phone", de: "Telefon" },
      emailInvalid: { en: "Enter a valid email address.", de: "Bitte eine gültige E-Mail-Adresse eingeben." },
    },
    dealerWebsiteTitle: { en: "Dealer Website", de: "Händler-Website" },
    siteStatus: {
      title: { en: "Site Status", de: "Site-Status" },
      no_site: { en: "No Site yet", de: "Noch keine Site" },
      offline: { en: "Offline", de: "Offline" },
      online: { en: "Online", de: "Online" },
      disabled: { en: "Disabled", de: "Deaktiviert" },
      site_deleted: { en: "Site Deleted", de: "Site gelöscht" },
    },
    statusChangePending: {
      en: (statusLabel) => `Status change pending sync with CMS (${statusLabel}).`,
      de: (statusLabel) => `Statusänderung wird mit CMS synchronisiert (${statusLabel}).`,
    },
    siteStatusActions: {
      deploy: { en: "Deploy Site (Offline Status)", de: "Site bereitstellen (Status Offline)" },
      bring_online: { en: "Bring Online", de: "Online schalten" },
      take_offline: { en: "Take Offline", de: "Offline schalten" },
      disable_site: { en: "Disable", de: "Deaktivieren" },
      delete_site: { en: "Delete Site", de: "Site löschen" },
    },
    deleteSiteConfirmTitle: {
      en: "Delete this site?",
      de: "Diese Site löschen?",
    },
    deleteSiteConfirmBody: {
      en: "This action is irreversible, and all content and data entered in this site will be permanently deleted. Are you sure you want to proceed?",
      de: "Diese Aktion ist unwiderruflich, und alle auf dieser Site eingegebenen Inhalte und Daten werden dauerhaft gelöscht. Möchten Sie wirklich fortfahren?",
    },
    deleteSiteConfirmInputLabel: {
      en: (url) => `Type the site's website URL to confirm (${url}):`,
      de: (url) => `Geben Sie die Website-URL der Site zur Bestätigung ein (${url}):`,
    },
    deleteSiteConfirmYes: { en: "Yes, delete this site", de: "Ja, diese Site löschen" },
    deleteSiteConfirmNo: { en: "No", de: "Nein" },
    confirmActionTitle: { en: "Confirm action", de: "Aktion bestätigen" },
    siteStatusConfirm: {
      deploy: {
        en: "Are you sure you want to deploy this site? It will be created with an Offline status.",
        de: "Möchten Sie diese Site wirklich bereitstellen? Sie wird mit dem Status Offline erstellt.",
      },
      bring_online: {
        en: "Are you sure you want to bring this site online?",
        de: "Möchten Sie diese Site wirklich online schalten?",
      },
      take_offline: {
        en: "Are you sure you want to take this site offline?",
        de: "Möchten Sie diese Site wirklich offline schalten?",
      },
      disable_site: {
        en: "Are you sure you want to disable this site?",
        de: "Möchten Sie diese Site wirklich deaktivieren?",
      },
    },
    hostRenameConfirmTitle: { en: "Rename website host?", de: "Website-Host umbenennen?" },
    hostRenameConfirmBody: {
      en: (newHost) =>
        `Are you sure you want to rename the website host to "${newHost}"? If this dealer's site already exists in the CMS, this will kick off a multi-step process with the CMS that may take a few minutes; the change only takes effect once that process completes.`,
      de: (newHost) =>
        `Möchten Sie den Website-Host wirklich in "${newHost}" umbenennen? Falls die Site dieses Händlers bereits im CMS existiert, wird dadurch ein mehrstufiger Prozess mit dem CMS gestartet, der einige Minuten dauern kann; die Änderung wird erst nach Abschluss dieses Prozesses wirksam.`,
    },
    hostRenameProgress: {
      en: (step, total, targetUrl) => `Now in step ${step} of ${total}: pending rename to ${targetUrl}`,
      de: (step, total, targetUrl) => `Aktuell in Schritt ${step} von ${total}: Umbenennung zu ${targetUrl} ausstehend`,
    },
    hostRenameFailed: { en: "Rename failed", de: "Umbenennung fehlgeschlagen" },
    assignExistingWebsiteBtn: { en: "Assign Existing Website", de: "Bestehende Website zuweisen" },
    assignExistingWebsiteDialogTitle: { en: "Assign Existing Website", de: "Bestehende Website zuweisen" },
    assignExistingWebsiteDialogBody: {
      en: "Enter the global ID of the existing website in the CMS that this dealer should be mapped to.",
      de: "Geben Sie die globale ID der bestehenden Website im CMS ein, der dieser Händler zugeordnet werden soll.",
    },
    assignExistingWebsiteInputLabel: { en: "Site Global ID", de: "Globale ID der Website" },
    assignExistingWebsiteConfirmTitle: { en: "Are you sure?", de: "Sind Sie sicher?" },
    assignExistingWebsiteConfirmBody: {
      en: (siteGlobalId) =>
        `This will map this dealer to the existing CMS site "${siteGlobalId}". If this dealer already has a website, its host, website and helper URLs will be overwritten once the CMS confirms the assignment. This is a critical action and may not be easily reversible. Are you sure you want to proceed?`,
      de: (siteGlobalId) =>
        `Dadurch wird dieser Händler der bestehenden CMS-Site "${siteGlobalId}" zugeordnet. Falls dieser Händler bereits eine Website hat, werden Host, Website- und Helfer-URL überschrieben, sobald das CMS die Zuweisung bestätigt. Dies ist eine kritische Aktion und möglicherweise nicht ohne Weiteres rückgängig zu machen. Möchten Sie wirklich fortfahren?`,
    },
    assignExistingWebsiteSaveErrorTitle: { en: "Could Not Assign Website", de: "Website konnte nicht zugewiesen werden" },
    assignExistingWebsiteProgress: {
      en: (step, total, siteGlobalId) => `Now in step ${step} of ${total}: pending assignment to site "${siteGlobalId}"`,
      de: (step, total, siteGlobalId) => `Aktuell in Schritt ${step} von ${total}: Zuweisung zu Site "${siteGlobalId}" ausstehend`,
    },
    assignExistingWebsiteFailed: { en: "Assignment failed", de: "Zuweisung fehlgeschlagen" },
    helperUrl: { en: "Helper URL", de: "Helfer-URL" },
    helperUrlHint: {
      en: "Lets the dealer preview their site before DNS is set up.",
      de: "Ermöglicht dem Händler die Vorschau der Site, bevor DNS eingerichtet ist.",
    },
    helperUrlEmpty: { en: "Not yet available", de: "Noch nicht verfügbar" },
    readiness: {
      title: { en: "Readiness", de: "Bereitschaft" },
      consentsSetupCompleted: { en: "Consents Setup Completed", de: "Einwilligungs-Setup abgeschlossen" },
      dnsSetupCompleted: { en: "DNS Setup Completed", de: "DNS-Setup abgeschlossen" },
      yes: { en: "Yes", de: "Ja" },
      no: { en: "No", de: "Nein" },
    },
    checkDataReadiness: { en: "Check Data Readiness", de: "Datenbereitschaft prüfen" },
    checkDataReadinessHint: {
      en: "Check if all necessary information has been entered in order to deploy your dealer website",
      de: "Prüfen Sie, ob alle erforderlichen Informationen eingegeben wurden, um Ihre Händler-Website bereitzustellen",
    },
    dataReadinessResultTitle: { en: "Data Readiness Check", de: "Datenbereitschaftsprüfung" },
    checkReadinessFailed: { en: "Failed to check data readiness", de: "Datenbereitschaft konnte nicht geprüft werden" },
    dataReadinessMessages: {
      legalInfoNotConfirmed: {
        en: "You have not checked the checkbox 'The legal information above is correct' in the Legal Pages section",
        de: "Sie haben das Kontrollkästchen 'Die oben genannten rechtlichen Angaben sind korrekt' im Bereich Impressum nicht aktiviert",
      },
      websiteHostBlank: {
        en: "The website host field must not be blank",
        de: "Das Feld für den Website-Host darf nicht leer sein",
      },
      mainContactEmailInvalid: {
        en: "The main contact email must be filled in with a valid email address",
        de: "Die E-Mail-Adresse des Hauptkontakts muss gültig ausgefüllt sein",
      },
      serviceHoursIncomplete: {
        en: (serviceType) => `The working hours and contact details (email and telephone) must be completed for the '${serviceType}' service`,
        de: (serviceType) => `Die Öffnungszeiten und Kontaktdaten (E-Mail und Telefon) müssen für den Service '${serviceType}' vollständig ausgefüllt sein`,
      },
      allInformationEntered: {
        en: "All necessary information has been entered",
        de: "Alle erforderlichen Informationen wurden eingegeben",
      },
    },
    websiteSaveErrorTitle: { en: "Could Not Save Website", de: "Website konnte nicht gespeichert werden" },
    sadConfirmations: {
      title: { en: "SAD Confirmations", de: "SAD-Bestätigungen" },
      signedDocuments: {
        en: "The Dealer has signed all necessary documentation",
        de: "Der Händler hat alle erforderlichen Unterlagen unterschrieben",
      },
      dataReviewed: {
        en: "Map co-ordinates and other related info have been properly reviewed",
        de: "Kartenkoordinaten und andere zugehörige Informationen wurden ordnungsgemäß überprüft",
      },
      commerciallyEligible: {
        en: "The dealer is commercially eligible to deploy a website",
        de: "Der Händler ist wirtschaftlich berechtigt, eine Website bereitzustellen",
      },
    },
    cookieConsentsLocal: {
      title: { en: "OneTrust Cookie Consent", de: "OneTrust Cookie-Einwilligung" },
      status: {
        SetupOnNextRun: { en: "Queued", de: "In Warteschlange" },
        InProgress: { en: "In Progress", de: "In Bearbeitung" },
        Success: { en: "Success", de: "Erfolgreich" },
        Error: { en: "Error", de: "Fehler" },
      },
      domainId: { en: "OneTrust Domain ID", de: "OneTrust-Domain-ID" },
      domainSource: { en: "Domain Source", de: "Domain-Quelle" },
      domainSourceProvisioned: { en: "Provisioned by us", de: "Von uns eingerichtet" },
      domainSourcePreexisting: { en: "Pre-existing in OneTrust", de: "Bereits in OneTrust vorhanden" },
      scriptId: { en: "Script ID (production)", de: "Skript-ID (Produktion)" },
      scriptIdTest: { en: "Script ID (test)", de: "Skript-ID (Test)" },
      publishStatus: { en: "Publish Status", de: "Veröffentlichungsstatus" },
      lastSyncedAt: { en: "Last Synced", de: "Zuletzt synchronisiert" },
      categories: { en: "Cookie Categories", de: "Cookie-Kategorien" },
      categoryName: { en: "Category", de: "Kategorie" },
      categoryCode: { en: "Code", de: "Code" },
      categoryStatus: { en: "Default Status", de: "Standardstatus" },
      queueSetup: { en: "Queue Setup", de: "Setup einreihen" },
      runNow: { en: "Create OneTrust Record", de: "OneTrust-Datensatz erstellen" },
      mustBeMigratedHint: {
        en: "Dealer must be migrated to DDM before queuing cookie consent setup",
        de: "Händler muss zu DDM migriert sein, bevor das Cookie-Einwilligungs-Setup eingereiht werden kann",
      },
      queued: { en: "Cookie consent setup queued", de: "Cookie-Einwilligungs-Setup eingereiht" },
      queueSetupDisabled: {
        en: "Bulk update queueing is temporarily disabled at code-level",
        de: "Massenaktualisierung in die Warteschlange ist vorübergehend auf Code-Ebene deaktiviert",
      },
      runNowStarted: { en: "OneTrust provisioning started", de: "OneTrust-Bereitstellung gestartet" },
      copied: { en: "Copied to clipboard", de: "In die Zwischenablage kopiert" },
      copyFailed: { en: "Copy failed", de: "Kopieren fehlgeschlagen" },
    },
  },
  legal: {
    title: { en: "Legal Pages Data", de: "Impressumsdaten" },
    breadcrumb: { en: "Legal Pages · Impressum", de: "Rechtsseiten · Impressum" },
    backToDealerDetails: { en: "Back to dealer details", de: "Zurück zu den Händlerdaten" },
    subtitle: {
      en: "Structured legal data (German Impressum) for the dealer's public website.",
      de: "Strukturierte Impressumsdaten für die öffentliche Händler-Website.",
    },
    incorporationType: { en: "Incorporation type", de: "Rechtsform" },
    select: { en: "Select…", de: "Auswählen…" },
    common: { en: "Common fields", de: "Gemeinsame Felder" },
    typeSpecific: { en: "Type-specific fields", de: "Rechtsformspezifische Felder" },
    dataProtectionInfo: { en: "Data Protection Info", de: "Datenschutzinformationen" },
    responsiblePerson: { en: "Responsible person", de: "Verantwortliche Person" },
    revocationEmail: { en: "Revocation email", de: "Widerrufs-E-Mail" },
    noticeText: { en: "Notice text", de: "Hinweistext" },
    customText: { en: "Custom Text", de: "Individueller Text" },
    customTextHintPrefix: {
      en: "Any additional legal notice or disclaimer that will appear on your public dealer page. Only ",
      de: "Zusätzliche rechtliche Hinweise oder Haftungsausschlüsse, die auf Ihrer öffentlichen Händlerseite erscheinen. Es werden nur ",
    },
    customTextHintBold: { en: "bold", de: "fett" },
    customTextHintSuffix: {
      en: " and plain text formatting are supported.",
      de: " und einfacher Text unterstützt.",
    },
    confirmCorrect: {
      en: "The legal information above is correct",
      de: "Die oben genannten rechtlichen Angaben sind korrekt",
    },
    revertChanges: { en: "Revert Changes", de: "Änderungen verwerfen" },
    noIncorporationTypeTitle: { en: "No Incorporation type selected", de: "Keine Rechtsform ausgewählt" },
    noIncorporationTypeDesc: {
      en: "Select an incorporation type before confirming the legal information is correct.",
      de: "Wählen Sie eine Rechtsform aus, bevor Sie bestätigen, dass die rechtlichen Angaben korrekt sind.",
    },
    tooManyBlankFieldsTitle: { en: "Too many blank fields", de: "Zu viele leere Felder" },
    tooManyBlankFieldsDesc: {
      en: "Are you sure the information is correct?",
      de: "Sind Sie sicher, dass die Angaben korrekt sind?",
    },
    preview: { en: "Preview", de: "Vorschau" },
  },
  templatePreview: {
    title: { en: "Impressum preview", de: "Impressum-Vorschau" },
    selectDealerTitle: { en: "Select a dealer to preview", de: "Händler für Vorschau auswählen" },
    searchPlaceholder: { en: "Search dealer name / code…", de: "Händlername/-code suchen…" },
    noBusinessForm: {
      en: "Select an incorporation type first.",
      de: "Wählen Sie zuerst eine Rechtsform aus.",
    },
    loadFailed: { en: "Preview failed", de: "Vorschau fehlgeschlagen" },
  },
  legalHtmlEditor: {
    breadcrumb: { en: "Legal HTML Editor", de: "Impressum-HTML-Editor" },
    title: { en: "Legal HTML Editor", de: "Impressum-HTML-Editor" },
    subtitle: {
      en: "Author the Impressum HTML template rendered for each business form.",
      de: "Erstellen Sie die Impressum-HTML-Vorlage für jede Rechtsform.",
    },
    businessForm: { en: "Business form", de: "Rechtsform" },
    lastSaved: { en: "Last saved", de: "Zuletzt gespeichert" },
    neverSaved: { en: "Not yet saved", de: "Noch nicht gespeichert" },
    previewForDealer: { en: "Preview for dealer…", de: "Vorschau für Händler…" },
    discardTitle: { en: "Discard unsaved changes?", de: "Ungespeicherte Änderungen verwerfen?" },
    discardDesc: {
      en: "Switching business form will discard your unsaved edits to this template.",
      de: "Beim Wechsel der Rechtsform gehen nicht gespeicherte Änderungen an dieser Vorlage verloren.",
    },
  },
  departments: {
    breadcrumb: { en: "Departments", de: "Abteilungen" },
    title: { en: "Departments", de: "Abteilungen" },
    subtitle: {
      en: "The department list assigned to employees dealer-wide, in English and German.",
      de: "Die Abteilungsliste, die Mitarbeitern händlerübergreifend zugewiesen wird, in Englisch und Deutsch.",
    },
    nameEn: { en: "English name", de: "Englischer Name" },
    nameDe: { en: "German name", de: "Deutscher Name" },
    columnEn: { en: "EN", de: "EN" },
    columnDe: { en: "DE", de: "DE" },
    addDepartment: { en: "Add department", de: "Abteilung hinzufügen" },
    empty: { en: "No departments yet.", de: "Noch keine Abteilungen." },
    nameRequired: { en: "Both names are required", de: "Beide Namen sind erforderlich" },
    removeConfirm: {
      en: (name) => `Delete "${name}"? Employees still assigned to it must be reassigned first.`,
      de: (name) => `„${name}“ löschen? Mitarbeiter, die ihr noch zugewiesen sind, müssen vorher neu zugewiesen werden.`,
    },
    removed: { en: "Deleted", de: "Gelöscht" },
    deleteFailed: { en: "Delete failed", de: "Löschen fehlgeschlagen" },
  },
  htmlEditor: {
    normal: { en: "Normal", de: "Normal" },
    heading1: { en: "Heading 1", de: "Überschrift 1" },
    heading2: { en: "Heading 2", de: "Überschrift 2" },
    heading3: { en: "Heading 3", de: "Überschrift 3" },
    italic: { en: "Italic", de: "Kursiv" },
    underline: { en: "Underline", de: "Unterstrichen" },
    bulletList: { en: "Bullet list", de: "Aufzählungsliste" },
    orderedList: { en: "Numbered list", de: "Nummerierte Liste" },
    alignLeft: { en: "Align left", de: "Linksbündig" },
    alignCenter: { en: "Align center", de: "Zentriert" },
    alignRight: { en: "Align right", de: "Rechtsbündig" },
    undo: { en: "Undo", de: "Rückgängig" },
    redo: { en: "Redo", de: "Wiederholen" },
    insertField: { en: "Insert field…", de: "Feld einfügen…" },
  },
  settings: {
    title: { en: "Settings", de: "Einstellungen" },
    subtitle: {
      en: "Integration keys and system configuration.",
      de: "Integrations-Schlüssel und Systemkonfiguration.",
    },
    googleMapsKey: { en: "Google Maps API key", de: "Google-Maps-API-Schlüssel" },
    googleMapsSub: {
      en: "Required for the coordinate map picker. Managed by MHQ Power Admin.",
      de: "Erforderlich für den Koordinaten-Kartendialog. Verwaltung durch MHQ-Power-Admin.",
    },
    brand: { en: "Branding", de: "Branding" },
    brandSub: {
      en: "Product name and logo — visible to all users. Managed by System Administrator only.",
      de: "Produktname und Logo — sichtbar für alle Benutzer. Nur System-Administrator.",
    },
    brandName: { en: "Product name", de: "Produktname" },
    brandLogo: { en: "Logo URL", de: "Logo-URL" },
    brandColor: { en: "Primary color (hex)", de: "Primärfarbe (Hex)" },
    brandSecondaryColor: { en: "Secondary color (hex)", de: "Sekundärfarbe (Hex)" },
    legalPages: { en: "Legal page paths", de: "Pfade der Rechtsseiten" },
    legalPagesSub: {
      en: "Relative paths used to build each dealer's legal-page URLs on demand: \"https://\" + dealer URL host + \".\" + dealer host suffix + \"/\" + path.",
      de: "Relative Pfade zum dynamischen Aufbau der Rechtsseiten-URLs je Händler: \"https://\" + Host-Teil der Händler-URL + \".\" + Domain-Suffix der Autohäuser + \"/\" + Pfad.",
    },
    imprintPath: { en: "Imprint path", de: "Impressum-Pfad" },
    privacyPath: { en: "Privacy policy path", de: "Datenschutz-Pfad" },
    cookiePolicyPath: { en: "Cookie policy path", de: "Cookie-Richtlinie-Pfad" },
    otherSettings: { en: "Other Settings", de: "Weitere Einstellungen" },
    dataChangeRequestEmail: { en: "Data Change Request Email", de: "E-Mail für Datenänderungsanfragen" },
    dataChangeRequestCcEmail: { en: "Data Change Request CC Email", de: "CC-E-Mail für Datenänderungsanfragen" },
    dealerHostSuffix: { en: "Dealer Host Suffix", de: "Domain-Suffix der Autohäuser" },
    dealerHostSuffixSub: {
      en: "The domain every dealer site lives under — e.g. \"skoda-auto.de\" in \"https://www-eins.skoda-auto.de\". Used to build every dealer's website, legal-page and employee-photo URLs. Managed by System Administrator only.",
      de: "Die Domain, unter der jede Händler-Website läuft — z. B. \"skoda-auto.de\" in \"https://www-eins.skoda-auto.de\". Wird verwendet, um die Website-, Rechtsseiten- und Mitarbeiterfoto-URLs jedes Autohauses zu erstellen. Nur System-Administrator.",
    },
    dealerHostSuffixLabel: { en: "Domain", de: "Domain" },
    dealerHostSuffixConfirmTitle: { en: "Critical setting", de: "Kritische Einstellung" },
    dealerHostSuffixConfirmBody: {
      en: "This is a critical edit that may break the entire application and all dealer websites. Are you sure you want to proceed? Write the word \"edit\" to proceed.",
      de: "Dies ist eine kritische Änderung, die die gesamte Anwendung und alle Händler-Websites beeinträchtigen kann. Möchten Sie wirklich fortfahren? Schreiben Sie das Wort \"edit\", um fortzufahren.",
    },
    dealerHostSuffixConfirmPlaceholder: { en: "Type \"edit\" to proceed", de: "„edit“ eingeben, um fortzufahren" },
    externalIp: { en: "External IP", de: "Externe IP" },
    externalIpSub: {
      en: "The public IP address other systems see when this application connects to them (e.g. for allow-lists). Managed by System Administrator only.",
      de: "Die öffentliche IP-Adresse, die andere Systeme sehen, wenn sich diese Anwendung mit ihnen verbindet (z. B. für Allow-Listen). Nur System-Administrator.",
    },
    externalIpButton: { en: "Get my external IP", de: "Meine externe IP abrufen" },
    externalIpFailed: { en: "Could not determine the external IP", de: "Externe IP konnte nicht ermittelt werden" },
    mdHash: { en: "MD Hash", de: "MD-Hash" },
    mdHashSub: {
      en: "The secret key and IV used to derive each dealer's md hash (AES-256-CBC of the company number) for the m-result iframe components. Saving a new value regenerates every dealer's md hash. Write-only. Managed by System Administrator only.",
      de: "Geheimer Schlüssel und IV, aus denen der md-Hash jedes Autohauses (AES-256-CBC der Firmennummer) für die m-result-iFrame-Komponenten abgeleitet wird. Beim Speichern eines neuen Werts werden alle md-Hashes neu erzeugt. Nur schreibbar. Nur System-Administrator.",
    },
    mdHashSecret: { en: "Secret key", de: "Geheimer Schlüssel" },
    mdHashIv: { en: "IV (exactly 16 characters)", de: "IV (genau 16 Zeichen)" },
    mdHashSetPlaceholder: { en: "Saved — type to replace", de: "Gespeichert — zum Ersetzen eingeben" },
    mdHashNotSet: { en: "Not set", de: "Nicht gesetzt" },
    mdHashRegenerateAll: { en: "Regenerate all", de: "Alle neu erzeugen" },
    mdHashRegenerateTitle: { en: "Regenerate all md hashes?", de: "Alle md-Hashes neu erzeugen?" },
    mdHashRegenerateBody: {
      en: "Every dealer's md hash is recomputed from the current secret key and IV. If the secret has not changed, the values stay the same.",
      de: "Der md-Hash jedes Autohauses wird aus dem aktuellen geheimen Schlüssel und IV neu berechnet. Hat sich das Geheimnis nicht geändert, bleiben die Werte gleich.",
    },
    mdHashStatus: {
      en: (n, total) => `${n} of ${total} dealers have a stored md hash`,
      de: (n, total) => `${n} von ${total} Autohäusern haben einen gespeicherten md-Hash`,
    },
    mdHashRegenerated: { en: (n) => `Regenerated ${n} md hashes`, de: (n) => `${n} md-Hashes neu erzeugt` },
  },
  profile: {
    breadcrumb: { en: "Profile", de: "Profil" },
    title: { en: "Profile", de: "Profil" },
    email: { en: "Email", de: "E-Mail" },
    firstName: { en: "First name", de: "Vorname" },
    lastName: { en: "Last name", de: "Nachname" },
    language: { en: "Language", de: "Sprache" },
    theme: { en: "Theme", de: "Erscheinungsbild" },
    themeLight: { en: "Light", de: "Hell" },
    themeDark: { en: "Dark", de: "Dunkel" },
    themeSystem: { en: "System", de: "System" },
    roles: { en: "Roles", de: "Rollen" },
    security: { en: "Security", de: "Sicherheit" },
    changePassword: { en: "Change password", de: "Passwort ändern" },
    changePasswordHint: {
      en: "Minimum 8 characters, at least one letter and one digit.",
      de: "Mindestens 8 Zeichen, mindestens ein Buchstabe und eine Ziffer.",
    },
    keycloakPasswordHint: {
      en: "Your password is managed by the single sign-on service. You will be asked to sign in there, change it, and then return here.",
      de: "Ihr Passwort wird vom Single-Sign-On-Dienst verwaltet. Sie melden sich dort an, ändern es und kehren anschließend hierher zurück.",
    },
    keycloakForgotPassword: { en: "Forgot your password?", de: "Passwort vergessen?" },
    currentPassword: { en: "Current password", de: "Aktuelles Passwort" },
    newPassword: { en: "New password", de: "Neues Passwort" },
    confirmNewPassword: { en: "Confirm new password", de: "Neues Passwort bestätigen" },
    passwordUpdated: { en: "Password updated", de: "Passwort aktualisiert" },
    changeFailed: { en: "Change failed", de: "Änderung fehlgeschlagen" },
  },
  // Role codes mirror backend/models.py ROLE_PERMISSIONS keys. An unknown
  // code falls back to the raw code (see roleLabel), so a role added on the
  // backend still renders — it just shows untranslated until listed here.
  roles: {
    SYSTEM_ADMIN: { en: "System Admin", de: "System-Administrator" },
    MHQ_ADMIN: { en: "MHQ Admin", de: "MHQ-Administrator" },
    SAD: { en: "Site Administrator (SAD)", de: "Site-Administrator (SAD)" },
    MHQ_CONTENT_MANAGER: { en: "MHQ Content Manager", de: "MHQ-Content-Manager" },
    MHQ_USER_MANAGER: { en: "MHQ User Manager", de: "MHQ-Benutzerverwalter" },
    MHQ_VIEWER: { en: "MHQ Viewer", de: "MHQ-Betrachter" },
    ACTIVATIONS_MANAGER: { en: "Activations Manager", de: "Aktivierungs-Manager" },
    IMPORT_OPERATOR: { en: "Import Operator", de: "Import-Operator" },
    MARKET_DNS_MANAGER: { en: "Market DNS Manager", de: "Markt-DNS-Manager" },
    DEALER_MAIN_USER: { en: "Dealer Main User", de: "Händler-Hauptbenutzer" },
    DEALER_POWER_CONTENT_MANAGER: { en: "Power Content Manager", de: "Power-Content-Manager" },
    DEALER_CONTENT_MANAGER: { en: "Content Manager", de: "Content-Manager" },
    DEALER_USER_MANAGER: { en: "User Manager", de: "Benutzerverwalter" },
  },
  // Permission keys mirror backend/models.py ALL_PERMISSIONS. Same fallback
  // rule as roles: an unlisted key renders as its raw code.
  permissions: {
    "dealer.read": { en: "View dealer", de: "Händler ansehen" },
    "dealer.main_contact.edit": { en: "Edit main contact", de: "Hauptkontakt bearbeiten" },
    "dealer.host_name.edit": { en: "Select host name", de: "Hostnamen wählen" },
    "dealer.certifications.edit": { en: "Edit certifications", de: "Zertifizierungen bearbeiten" },
    "dealer.legal_pages.edit": { en: "Edit legal pages", de: "Rechtliche Seiten bearbeiten" },
    "dealer.branch.edit": { en: "Edit branch info", de: "Filialdaten bearbeiten" },
    "dealer.branch.coordinates.edit": { en: "Edit map coordinates", de: "Kartenkoordinaten bearbeiten" },
    "dealer.services.edit": { en: "Edit services & opening hours", de: "Services & Öffnungszeiten bearbeiten" },
    "dealer.services.manage": { en: "Add / remove services", de: "Services hinzufügen / entfernen" },
    "dealer.employees.manage": { en: "Manage employees", de: "Mitarbeiter verwalten" },
    "dealer.social_media.edit": { en: "Edit social media links", de: "Social-Media-Links bearbeiten" },
    "dealer.content.manage": { en: "General content management", de: "Allgemeine Inhaltsverwaltung" },
    "dealer.site_status.toggle": { en: "Take website online / offline", de: "Website online / offline schalten" },
    "dealer.site.deploy": { en: "Deploy / disable / delete site", de: "Site bereitstellen / deaktivieren / löschen" },
    "dealer.sad_confirmations.edit": { en: "Edit SAD confirmations", de: "SAD-Bestätigungen bearbeiten" },
    "dealer.ddm_migration.manage": { en: "Manage DDM migration flag", de: "DDM-Migrationskennzeichen verwalten" },
    "dealer.cookie_consents.manage": { en: "Manage cookie consents", de: "Cookie-Einwilligungen verwalten" },
    "dealer.dns.manage": { en: "Manage DNS setup", de: "DNS-Einrichtung verwalten" },
    "users.manage": { en: "Manage users & roles", de: "Benutzer & Rollen verwalten" },
    "network.dealers.read": { en: "View all dealers", de: "Alle Händler ansehen" },
    "network.impersonate": { en: "Impersonate a dealer", de: "Als Händler agieren" },
    "network.legal_templates.manage": { en: "Manage legal HTML templates", de: "Rechtliche HTML-Vorlagen verwalten" },
    "activations.manage": { en: "Manage activations", de: "Aktivierungen verwalten" },
    "imports.run": { en: "Run the dealer feed import", de: "Händler-Feed-Import ausführen" },
    "imports.archives.delete": { en: "Delete feed archives", de: "Feed-Archive löschen" },
    "system.settings.manage": { en: "Manage settings", de: "Einstellungen verwalten" },
    "system.branding.manage": { en: "Manage branding", de: "Branding verwalten" },
    "system.api_tokens.manage": { en: "Manage API tokens", de: "API-Tokens verwalten" },
    "system.audit.read": { en: "View audit & API logs", de: "Audit- & API-Protokolle ansehen" },
    "system.dev_tools": { en: "Developer tools", de: "Entwicklerwerkzeuge" },
    "system.restart": { en: "Restart the application", de: "Anwendung neu starten" },
    "system.departments.manage": { en: "Manage departments", de: "Abteilungen verwalten" },
    "system.keycloak.manage": { en: "Manage Keycloak settings", de: "Keycloak-Einstellungen verwalten" },
  },
  users: {
    columns: {
      dealers: { en: "Dealers", de: "Autohäuser" },
    },
    scope: {
      mhq: { en: "MHQ user", de: "MHQ-Benutzer" },
      dealer: { en: "Dealer user", de: "Händler-Benutzer" },
    },
    dealersTooltip: {
      en: (names) => `Mapped to: ${names.join(", ")}`,
      de: (names) => `Zugeordnet zu: ${names.join(", ")}`,
    },
    dealerAccess: {
      title: { en: "Dealer access", de: "Händlerzugriff" },
      addDealer: { en: "Add dealer", de: "Autohaus hinzufügen" },
      removeDealer: { en: "Remove", de: "Entfernen" },
      selectDealer: { en: "Select a dealer…", de: "Autohaus auswählen…" },
      noneYet: {
        en: "No dealers mapped yet. Click “Add dealer” to grant access.",
        de: "Noch keine Autohäuser zugeordnet. Klicken Sie auf „Autohaus hinzufügen“, um Zugriff zu gewähren.",
      },
      noAssignable: {
        en: "No further dealers are available to assign — you can only grant access to dealers you manage yourself.",
        de: "Es sind keine weiteren Autohäuser verfügbar — Sie können nur Zugriff auf Autohäuser gewähren, die Sie selbst verwalten.",
      },
    },
  },
  myDealerships: {
    title: { en: "My Dealerships", de: "Meine Autohäuser" },
    subtitle: {
      en: "The dealerships you have access to. Select one to view its details.",
      de: "Die Autohäuser, auf die Sie Zugriff haben. Wählen Sie eines aus, um die Details anzuzeigen.",
    },
    columns: {
      actions: { en: "Actions", de: "Aktionen" },
    },
    viewDetails: { en: "View details", de: "Details anzeigen" },
    visitWebsite: { en: "Visit website", de: "Website besuchen" },
    noWebsiteYet: { en: "Website not deployed yet", de: "Website noch nicht bereitgestellt" },
    empty: { en: "No dealerships mapped to your account.", de: "Ihrem Konto sind keine Autohäuser zugeordnet." },
  },
  audit: {
    title: { en: "Audit Log", de: "Audit-Protokoll" },
    subtitle: {
      en: "Recent actions performed in the platform.",
      de: "Letzte Aktionen auf der Plattform.",
    },
    export: { en: "Export to Excel", de: "Nach Excel exportieren" },
    exportTitle: { en: "Export audit log", de: "Audit-Protokoll exportieren" },
    exportSubtitle: {
      en: "Choose the date/time range to export.",
      de: "Wählen Sie den zu exportierenden Zeitraum.",
    },
    from: { en: "From", de: "Von" },
    to: { en: "To", de: "Bis" },
    exportAction: { en: "Export", de: "Exportieren" },
    exporting: { en: "Exporting…", de: "Exportiert…" },
    exportError: { en: "Export failed", de: "Export fehlgeschlagen" },
    detailTitle: { en: "Audit entry details", de: "Details des Audit-Eintrags" },
    timestamp: { en: "Timestamp", de: "Zeitstempel" },
    actor: { en: "Actor", de: "Akteur" },
    action: { en: "Action", de: "Aktion" },
    entityType: { en: "Entity type", de: "Objekttyp" },
    entityId: { en: "Entity ID", de: "Objekt-ID" },
    impersonating: { en: "Impersonating", de: "Impersoniert" },
    source: { en: "Source", de: "Quelle" },
    before: { en: "Before", de: "Vorher" },
    after: { en: "After", de: "Nachher" },
  },
  legalTypes: {
    SoleProprietorship: { en: "Sole Proprietorship", de: "Einzelunternehmen" },
    eK: { en: "e.K.", de: "e.K." },
    GbR: { en: "GbR", de: "GbR" },
    OHGKG: { en: "OHG / KG", de: "OHG / KG" },
    GmbH: { en: "GmbH", de: "GmbH" },
    GmbHCoKG: { en: "GmbH & Co. KG", de: "GmbH & Co. KG" },
    AG: { en: "AG", de: "AG" },
  },
  serviceTypes: {
    Sales: { en: "Sales", de: "Vertrieb" },
    UsedCarSales: { en: "Used Car Sales", de: "Gebrauchtwagenverkauf" },
    Service: { en: "Service", de: "Service" },
    HeavyCrashPartners: { en: "Accident Specialist", de: "Unfallspezialist" },
    SalesOthers: { en: "Fleet Sales Competence Center", de: "Großkunden Leistungszentrum Vertrieb" },
    Others2Service: { en: "Parts Discount x2", de: "Teilerabatt x2" },
  },
  boldEditor: {
    bold: { en: "Bold", de: "Fett" },
    boldLower: { en: "bold", de: "fett" },
    plainTextPrefix: { en: "Plain text · ", de: "Klartext · nur " },
    plainTextSuffix: { en: " only", de: "" },
    placeholder: {
      en: "Add any additional legal notice, disclaimer, or dispute-resolution text here…",
      de: "Fügen Sie hier zusätzliche rechtliche Hinweise, Haftungsausschlüsse oder Hinweise zur Streitbeilegung hinzu…",
    },
  },
  employees: {
    title: {
      en: (count) => `Employees (${count})`,
      de: (count) => `Mitarbeiter (${count})`,
    },
    addEmployee: { en: "Add employee", de: "Mitarbeiter hinzufügen" },
    empty: { en: "No employees on file for this dealer.", de: "Für diesen Händler sind keine Mitarbeiter hinterlegt." },
    name: { en: "Name", de: "Name" },
    jobTitle: { en: "Title", de: "Titel" },
    department: { en: "Department", de: "Abteilung" },
    departmentNone: { en: "— None —", de: "— Keine —" },
    departmentImported: { en: "Department (imported)", de: "Abteilung (importiert)" },
    phone: { en: "Phone", de: "Telefon" },
    email: { en: "Email", de: "E-Mail" },
    position: { en: "Position", de: "Position" },
    languages: { en: "Languages", de: "Sprachen" },
    photoUrl: { en: "Photo URL", de: "Foto-URL" },
    largePhotoUrl: { en: "Large photo URL", de: "Große Foto-URL" },
    nameRequired: { en: "Name is required", de: "Name ist erforderlich" },
    removed: { en: "Removed", de: "Entfernt" },
    deleteFailed: { en: "Delete failed", de: "Löschen fehlgeschlagen" },
    removeConfirm: {
      en: (name) => `Remove ${name} from the staff list?`,
      de: (name) => `${name} aus der Mitarbeiterliste entfernen?`,
    },
    noPhoto: { en: "No photo", de: "Kein Foto" },
    photoOld: { en: "Old (feed)", de: "Alt (Feed)" },
    photoNew: { en: "New (renamed)", de: "Neu (umbenannt)" },
    uploadPhoto: { en: "Upload photo", de: "Foto hochladen" },
    replacePhoto: { en: "Replace photo", de: "Foto ersetzen" },
    deletePhoto: { en: "Delete photo", de: "Foto löschen" },
    deletePhotoConfirm: {
      en: (name) => `Delete ${name}'s photo?`,
      de: (name) => `Foto von ${name} löschen?`,
    },
    photoUploaded: { en: "Photo uploaded", de: "Foto hochgeladen" },
    photoUploadFailed: { en: "Photo upload failed", de: "Foto-Upload fehlgeschlagen" },
    photoDeleted: { en: "Photo deleted", de: "Foto gelöscht" },
    photoDeleteFailed: { en: "Photo delete failed", de: "Foto konnte nicht gelöscht werden" },
    forceOverwrite: { en: "Force overwrite from old feed", de: "Von altem Feed erzwingen" },
    forceOverwriteConfirm: {
      en: (name) => `Re-download ${name}'s photo from the feed, overwriting the current one?`,
      de: (name) => `Foto von ${name} erneut vom Feed herunterladen und das aktuelle überschreiben?`,
    },
    forceOverwriteDone: { en: "Photo re-downloaded from feed", de: "Foto erneut vom Feed geladen" },
    forceOverwriteFailed: { en: "Re-download from feed failed", de: "Erneuter Download vom Feed fehlgeschlagen" },
    forceOverwriteNoFeedPhoto: {
      en: "No feed photo on file for this employee",
      de: "Für diesen Mitarbeiter ist kein Feed-Foto hinterlegt",
    },
  },
  // See docs/specs/bulk-update-dealers-20260904.md
  bulkUpdate: {
    title: { en: "Bulk Update Dealers", de: "Händler in Masse aktualisieren" },
    subtitle: {
      en: "Apply one update action to many dealers at once.",
      de: "Eine Aktualisierung auf mehrere Händler gleichzeitig anwenden.",
    },
    cookieConsentBulkDisabled: {
      en: "Bulk update queueing is temporarily disabled at code-level",
      de: "Massenaktualisierung in die Warteschlange ist vorübergehend auf Code-Ebene deaktiviert",
    },
    actionCardTitle: { en: "Select Bulk Update Action", de: "Massenaktualisierung auswählen" },
    setTo: {
      label: { en: "Set to", de: "Setzen auf" },
      true: { en: "True", de: "Wahr" },
      false: { en: "False", de: "Falsch" },
    },
    actions: {
      ddmMigration: {
        label: { en: "Update 'Migrated to DDM' flag", de: "Flag „Zu DDM migriert“ aktualisieren" },
      },
      certification: {
        label: { en: "Update Certification", de: "Zertifizierung aktualisieren" },
        fieldLabel: { en: "Certification", de: "Zertifizierung" },
      },
      service: {
        label: { en: "Add/Remove Services", de: "Services hinzufügen/entfernen" },
        fieldLabel: { en: "Service", de: "Service" },
        modeLabel: { en: "Mode", de: "Modus" },
        add: { en: "Add", de: "Hinzufügen" },
        remove: { en: "Remove", de: "Entfernen" },
      },
      cookieConsent: {
        label: { en: "Cookie Consent setup", de: "Cookie-Einwilligung einrichten" },
        directionLabel: { en: "Direction", de: "Richtung" },
        add: { en: "Add to OneTrust", de: "Zu OneTrust hinzufügen" },
        remove: { en: "Remove from OneTrust", de: "Von OneTrust entfernen" },
      },
      siteStatus: {
        label: { en: "Website Status", de: "Website-Status" },
        fieldLabel: { en: "Action", de: "Aktion" },
      },
    },
    fields: {
      certified_seller: { en: "Certified Seller", de: "Zertifizierter Verkäufer" },
      financial_certified: { en: "Financial Certified", de: "Finanzzertifiziert" },
      skoda_club: { en: "Skoda Club", de: "Skoda Club" },
      cookieConsentStatus: { en: "Cookie Consent Status", de: "Cookie-Einwilligungsstatus" },
    },
    dealerCodes: {
      label: { en: "Dealer Codes", de: "Händlercodes" },
      hint: {
        en: "Paste dealer codes, comma-separated or one per line. With or without the \"107-\" prefix.",
        de: "Händlercodes einfügen, durch Komma getrennt oder eine Zeile je Code. Mit oder ohne das Präfix „107-“.",
      },
      placeholder: {
        en: "107-1234567, 107-7654321\n107-1112223",
        de: "107-1234567, 107-7654321\n107-1112223",
      },
    },
    next: { en: "Next", de: "Weiter" },
    back: { en: "Back", de: "Zurück" },
    review: {
      title: { en: "Review Changes", de: "Änderungen überprüfen" },
      filterAll: { en: "All", de: "Alle" },
      filterChanging: { en: "Changing values only", de: "Nur geänderte Werte" },
      filterIssues: { en: "Issues only", de: "Nur Probleme" },
      columns: {
        dealerCode: { en: "Dealer Code", de: "Händlercode" },
        dealerName: { en: "Dealer Name", de: "Händlername" },
        current: {
          en: (field) => `${field} (Current)`,
          de: (field) => `${field} (Aktuell)`,
        },
        newValue: {
          en: (field) => `${field} (New)`,
          de: (field) => `${field} (Neu)`,
        },
      },
      na: { en: "N/A", de: "N/V" },
      noValue: { en: "None", de: "Keine" },
      notFound: { en: "Dealer code not found", de: "Händlercode nicht gefunden" },
      duplicate: { en: "duplicate — skipped", de: "Duplikat — übersprungen" },
      notApplicable: {
        en: "Action not applicable to this dealer's current state",
        de: "Aktion für den aktuellen Status dieses Händlers nicht anwendbar",
      },
      pendingChange: {
        en: "A status change is already pending sync with the CMS for this dealer",
        de: "Für diesen Händler ist bereits eine Statusänderung mit dem CMS ausstehend",
      },
      resultsCount: {
        en: (n) => `${n} dealer${n === 1 ? "" : "s"}`,
        de: (n) => `${n} Händler`,
      },
      selectedCount: {
        en: (n) => `${n} selected`,
        de: (n) => `${n} ausgewählt`,
      },
      update: { en: "Update", de: "Aktualisieren" },
      noRows: { en: "No dealers to show.", de: "Keine Händler vorhanden." },
    },
    progress: {
      title: { en: "Updating Dealers…", de: "Händler werden aktualisiert…" },
      count: {
        en: (done, total) => `${done} / ${total} processed`,
        de: (done, total) => `${done} / ${total} verarbeitet`,
      },
    },
    results: {
      title: { en: "Bulk Update Complete", de: "Massenaktualisierung abgeschlossen" },
      processed: { en: "Processed", de: "Verarbeitet" },
      succeeded: { en: "Succeeded", de: "Erfolgreich" },
      failed: { en: "Failed", de: "Fehlgeschlagen" },
      errorsTitle: { en: "Errors", de: "Fehler" },
      backToDealers: { en: "Back to Dealers", de: "Zurück zu Händlern" },
      startAnother: { en: "Start Another Bulk Update", de: "Weitere Massenaktualisierung starten" },
    },
  },
};

export function t(path, lang, ...args) {
  const parts = path.split(".");
  let node = dict;
  for (const p of parts) {
    if (node == null) return path;
    node = node[p];
  }
  if (!node) return path;
  const value = node[lang] ?? node.en;
  if (typeof value === "function") return value(...args);
  return value;
}

export function roleLabel(role, lang) {
  return dict.roles[role] ? t(`roles.${role}`, lang) : role;
}

export function permissionLabel(permission, lang) {
  return dict.permissions[permission] ? dict.permissions[permission][lang] ?? dict.permissions[permission].en : permission;
}

export function permissionLabels(permissions, lang) {
  return (permissions || []).map((p) => permissionLabel(p, lang));
}

export const LEGAL_TYPES = [
  "SoleProprietorship",
  "eK",
  "GbR",
  "OHGKG",
  "GmbH",
  "GmbHCoKG",
  "AG",
];

// Field visibility matrix per §2.3 of functional specs
export const LEGAL_FIELDS_BY_TYPE = {
  common: ["email", "vat_id", "responsible"],
  SoleProprietorship: [],
  eK: ["managing_director", "registration_court", "commercial_register_no"],
  GbR: ["partners"],
  OHGKG: [
    "registration_court",
    "commercial_register_no",
    "registered_office",
    "authorized_representative_partner",
  ],
  GmbH: [
    "managing_director",
    "registration_court",
    "commercial_register_no",
    "registered_office",
  ],
  GmbHCoKG: [
    "registration_court",
    "commercial_register_no",
    "managing_partner",
    "registration_court_of_partner",
    "commercial_register_no_of_partner",
    "representative",
  ],
  AG: [
    "registration_court",
    "commercial_register_no",
    "registered_office",
    "supervisory_board_chair",
    "board_chair",
    "board",
  ],
};

export const LEGAL_INFO_TEXT = {
  OHGKG: {
    en: "All authorized representative partners must be listed.",
    de: "Alle vertretungsberechtigten Gesellschafter müssen aufgeführt werden.",
  },
  GmbH: {
    en: "The authorized managing director(s) must be listed.",
    de: "Der/die vertretungsberechtigte(n) Geschäftsführer müssen aufgeführt werden.",
  },
  AG: {
    en: "The entire authorized board must be listed.",
    de: "Der gesamte vertretungsberechtigte Vorstand muss aufgeführt werden.",
  },
};

export const LEGAL_FIELD_LABELS = {
  email: { en: "Email", de: "E-Mail" },
  vat_id: { en: "VAT ID No.", de: "USt-IdNr." },
  responsible: { en: "Responsible", de: "Verantwortlich" },
  managing_director: { en: "Managing Director", de: "Geschäftsführer" },
  registration_court: { en: "Registration Court", de: "Registergericht" },
  commercial_register_no: {
    en: "Commercial Register No.",
    de: "Handelsregister-Nr.",
  },
  registered_office: { en: "Registered Office", de: "Sitz" },
  partners: { en: "Partners", de: "Gesellschafter" },
  authorized_representative_partner: {
    en: "Authorized Representative Partner",
    de: "Vertretungsberechtigter Gesellschafter",
  },
  managing_partner: { en: "Managing Partner", de: "Geschäftsführender Gesellschafter" },
  registration_court_of_partner: {
    en: "Registration Court of Partner",
    de: "Registergericht des Gesellschafters",
  },
  commercial_register_no_of_partner: {
    en: "Commercial Register No. of Partner",
    de: "Handelsregister-Nr. des Gesellschafters",
  },
  representative: { en: "Representative", de: "Vertreter" },
  supervisory_board_chair: {
    en: "Supervisory Board Chair",
    de: "Vorsitzender des Aufsichtsrats",
  },
  board_chair: { en: "Board Chair", de: "Vorstandsvorsitzender" },
  board: { en: "Board", de: "Vorstand" },
  // Global fields — shown regardless of incorporation type (see LegalPages.jsx's
  // "Data Protection Info" section and Custom Text editor).
  data_protection_responsible_name: { en: "Responsible person", de: "Verantwortliche Person" },
  data_protection_revocation_email: { en: "Revocation email", de: "Widerrufs-E-Mail" },
  data_protection_notice_text: { en: "Notice text", de: "Hinweistext" },
  custom_text_html: { en: "Custom Text", de: "Individueller Text" },
};

// Global fields available as placeholders on every business form's template —
// not gated by LEGAL_FIELDS_BY_TYPE since they're always shown on the Legal
// Pages page regardless of incorporation_type.
export const GLOBAL_LEGAL_FIELDS = [
  "data_protection_responsible_name",
  "data_protection_revocation_email",
  "data_protection_notice_text",
  "custom_text_html",
];

// Every field insertable as a `{{field_key}}` placeholder for a given
// business form — common + type-specific + the global fields above. Used by
// the Legal HTML Editor's "Insert field" dropdown.
export function legalPlaceholderFields(businessForm, lang) {
  const keys = [
    ...LEGAL_FIELDS_BY_TYPE.common,
    ...(LEGAL_FIELDS_BY_TYPE[businessForm] || []),
    ...GLOBAL_LEGAL_FIELDS,
  ];
  return keys.map((key) => ({ key, label: LEGAL_FIELD_LABELS[key]?.[lang] || key }));
}
